import React, { Suspense } from "react";

const AiUsage = React.lazy(() => import("@/pages/ai-usage"));

export default function AiUsageContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <AiUsage />
    </Suspense>
  );
}
